<script setup lang="ts">
import { useIntersectionObserver } from '@vueuse/core';

interface Props {
  /**
   * Margem antes de começar a carregar (em px)
   * Ex: 200 = começa a carregar 200px antes de entrar na viewport
   */
  rootMargin?: string;
  /**
   * Threshold para trigger (0 = qualquer pixel visível, 1 = 100% visível)
   */
  threshold?: number;
  /**
   * Altura mínima do placeholder (evita layout shift)
   */
  minHeight?: string;
}

const {
  rootMargin = '200px',
  threshold = 0,
  minHeight = '400px',
} = defineProps<Props>();

const target = ref<HTMLElement | null>(null);
const isVisible = ref(false);

useIntersectionObserver(
  target,
  (entries) => {
    const entry = entries[0];

    if (entry?.isIntersecting && !isVisible.value) {
      isVisible.value = true;
    }
  },
  {
    rootMargin,
    threshold,
  },
);
</script>

<template>
  <div
    ref="target"
    :style="{ minHeight: isVisible ? 'auto' : minHeight }"
  >
    <slot v-if="isVisible" />
  </div>
</template>
